namespace GeniuzPOS.QRreport {
    export interface QHourTimeForm {
        HourTime: Serenity.IntegerEditor;
        HourTimeName: Serenity.StringEditor;
        HourTimeNameEn: Serenity.StringEditor;
    }

    export class QHourTimeForm extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QHourTime';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QHourTimeForm.init)  {
                QHourTimeForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(QHourTimeForm, [
                    'HourTime', w0,
                    'HourTimeName', w1,
                    'HourTimeNameEn', w1
                ]);
            }
        }
    }
}
